// extracted by mini-css-extract-plugin
export default {"controls":"CalendarControl_controls__z5Ust","navbtns":"CalendarControl_navbtns__KRdF1"};